import React from 'react';

export const pageMeta = {
  "name": "JSON vs XML",
  "link": "/javascript/json/vs-xml"
};

export default function JavascriptJsonVsXml() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JSON vs XML</h2>
      <p>Route: /javascript/json/vs-xml</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
